import { Box } from "@mui/material";
import Formbody from "./Formbody";

const TermsForm = () => {
    return (
        <Box
            className="card"
        >
            <Box
                className="card-body"
            >
                <h2 className="title">Termos de uso</h2>
                <p className="text-muted">Aqui é possível modificar os termos de uso</p>
                <hr/>
                <Formbody/>
            </Box>
        </Box>
    );
}

export default TermsForm;